module.exports = __webpack_public_path__ + "static/media/CaslonGraD.ec47572c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CaslonGraD.ttf
// module id = 1652
// module chunks = 49